const errorText = {
  invalid: '用户名或密码不能为空；用户名不超过 20 位。',
  denied: '用户名或密码不对，或账号已停用。',
  locked: '尝试次数过多，请稍后再试。',
  server: '登录服务暂时不可用。',
};

function showError(message) {
  const node = document.getElementById('loginError');
  node.hidden = !message;
  node.textContent = message || '';
}

document.getElementById('loginForm').addEventListener('submit', async (event) => {
  event.preventDefault();
  showError('');
  try {
    const response = await fetch('/api/login', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        username: document.getElementById('username').value,
        password: document.getElementById('password').value,
      }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      showError(errorText[data.error] || errorText.server);
      return;
    }
    localStorage.setItem('bead-grid-studio:access', 'full');
    location.href = './';
  } catch (_) {
    showError(errorText.server);
  }
});
